(function () {
    'use strict';

    var socialFeedSliders = document.querySelectorAll('.org-social-feed-block');

    function checkArrows(swiper) {
        if (swiper.isBeginning && swiper.isEnd) {
            $(swiper.navigation.prevEl).addClass('hide-prevnext');
            $(swiper.navigation.nextEl).addClass('hide-prevnext');
        } else {
            $(swiper.navigation.prevEl).removeClass('hide-prevnext');
            $(swiper.navigation.nextEl).removeClass('hide-prevnext');
        }
    }

    socialFeedSliders.forEach((socialFeedSlider) => {
        const nextEl = socialFeedSlider.querySelector('.swiper-next');
        const prevEl = socialFeedSlider.querySelector('.swiper-prev');

        var swiperContainer =
            socialFeedSlider.querySelector('.swiper');

        new Swiper(swiperContainer, {
            slidesPerView: 1.3,
            spaceBetween: 32,
            watchOverflow: true,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl,
            },
            breakpoints: {
                0: {
                    slidesPerView: 1.3,
                    spaceBetween: 16,
                },
                768: {
                    slidesPerView: 2,
                },
                1248: {
                    slidesPerView: 3,
                },
            },
            on: {
                afterInit: function () {
                    checkArrows(this);
                },
                resize: function () {
                    checkArrows(this);
                },
            },
        });
    })
})();
